import { Component } from '@angular/core';
import { SelectWidget as _SelectWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

type SelectOptionValue = string | number | boolean;

type SelectOption = {
  value: SelectOptionValue;
  label: string;
};

type SelectOptgroup = {
  label: string;
  valuePrefix: string;
  options: Array<SelectOption>;
};

@Component( {
  selector: 'sp-select-widget',
  templateUrl: './select.widget.html',
} )
export class SelectWidget extends _SelectWidget {
  schema: JSONSchema;
  blank: SelectOption = { value: null, label: 'Please select' };

  constructor() {
    super();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    switch ( this.schema.type ) {
      case 'string': this.blank.value = ''; break;
      case 'number': this.blank.value = null; break;
      case 'integer': this.blank.value = null; break;
      case 'boolean': this.blank.value = null; break;
    }

    if ( this.schema.options && typeof this.schema.options.enumBlankTitle !== 'undefined' ) {
      this.blank.label = this.schema.options.enumBlankTitle;
    }
  }

  get hasBlank() {
    return typeof this.widget.hasBlank !== 'undefined' ? this.widget.hasBlank : true;
  }

  get widget() {
    let widget = this.schema.widget;
    return typeof widget === 'string' ? ( { id: widget } ) : widget;
  }

  get options(): Array<SelectOption> {
    let values: Array<SelectOptionValue> = this.schema.enum || null;
    let labels: Array<string> = ( this.schema.options && this.schema.options.enum_titles ) || null;

    if ( this.schema.type === 'boolean' ) {
      values = values || [ true, false ];
      labels = labels || [ 'Yes', 'No' ];
    }

    // Generate numerical values between max and min
    // Assumes values are integers
    if ( ( this.schema.type === 'number' || this.schema.type === 'integer' ) && values === null &&
      ( typeof this.schema.minimum !== 'undefined' || typeof this.schema.exclusiveMinimum !== 'undefined' ) &&
      ( typeof this.schema.maximum !== 'undefined' || typeof this.schema.exclusiveMaximum !== 'undefined' )
    ) {
      const min = typeof this.schema.minimum !== 'undefined' ? this.schema.minimum : this.schema.exclusiveMinimum + 1;
      const max = typeof this.schema.maximum !== 'undefined' ? this.schema.maximum : this.schema.exclusiveMaximum - 1;
      values = Array( max - min + 1 ).fill( min ).map( ( v, i ) => v + i );
      labels = [ ...values ].map( v => v.toString() );
    }

    values = values || [];
    labels = labels || [];

    return [
      ...this.hasBlank ? [ this.blank ] : [],
      ...values.map( ( value, index ): SelectOption => ( { value, label: labels[ index ] } ) ),
    ];
  }

  get selectOptions(): Array<SelectOption | SelectOptgroup> {
    let optgroup: SelectOptgroup;
    return this.options.reduce( ( optionList: Array<SelectOption | SelectOptgroup>, option, optionIndex, allOptions ) => {
      const groupPrefix = 'GROUP_';
      const optVal = option.value === null ? '' : option.value.toString();
      if ( optgroup && ( !optVal.startsWith( optgroup.valuePrefix ) || optionIndex === allOptions.length - 1 ) ) {
        // Finished group
        optionList.push( optgroup );
        optgroup = null;
      }
      if ( !optgroup && optVal.startsWith( groupPrefix ) ) {
        optgroup = {
          label: option.label,
          valuePrefix: optVal.substring( groupPrefix.length ),
          options: [],
        };
      } else {
        if ( optgroup ) {
          optgroup.options.push( option );
        } else {
          optionList.push( option );
        }
      }
      return optionList;
    }, [] );
  }

  optionIdentity( index: string, option: SelectOption ): SelectOptionValue {
    return option.value;
  }

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/select.widget.ts